import { UserRoles } from '@/enums';
import { Auth } from '@/modules/auth/types';
import { user_store } from '@/store';
import { MiddlewarePayload } from '@/types';

export default function access_roles(payload: MiddlewarePayload) {
  const { to, next_middleware, next } = payload;
  const { roles = [] } = user_store.getters.me_shared;
  const access_roles = to?.meta?.access_roles;

  let can_show = false;

  if (to.name !== Auth.Pages.SIGN_IN) {
    if (access_roles && access_roles?.length) {
      can_show = access_roles.some(
        (el: UserRoles.Internal | UserRoles.External) => roles.some(
          (role) => role.slug === el,
        ),
      );
    }

    if (can_show) {
      return next_middleware();
    }

    if (to.name !== 'home') {
      return next({ name: 'home' });
    }
  }
  return next_middleware();
}
